import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Grid,
  Card,
  Title,
  Text,
  Button,
  Group,
  Center,
} from "@mantine/core";
import logo from "../../../assets/img/paykit _logo1.webp";

function UnauthorizedPage({
  icon,
  leftTitle = "Access Denied",
  leftMessage = "You don’t have permission to view this page.",
  rightTitle = "You’re not authorized",
  rightMessage = "Without proper access, you cannot continue.",
  actions = [
    {
      label: "Request Access",
      href: "",
      variant: "outline",
    },
  ],
  leftGradient = "linear-gradient(135deg, #2563EB 0%, #1E3A8A 100%)",
}) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--mantine-color-gray-0)",
        zIndex: 40,
        padding: "1rem",
      }}
    >
      <Container fluid px="md" style={{ maxHeight: "100%" }}>
        <Center style={{ minHeight: 400 }}>
          <Card
            shadow="md"
            radius="lg"
            withBorder
            style={{ width: "100%", maxWidth: 900, overflow: "hidden" }}
          >
            <Grid>
              <Grid.Col
                md={5}
                sm={12}
                style={{
                  background: leftGradient,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "3rem 1.5rem",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.1)",
                      borderRadius: "50%",
                      width: 80,
                      height: 80,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 1rem",
                    }}
                  >
                    {icon || (
                      <img
                        src={logo}
                        alt="Paykit"
                        style={{ width: 56, height: 56, objectFit: "contain" }}
                      />
                    )}
                  </div>
                  <Title order={2} fw={600} mb={8}>
                    {leftTitle}
                  </Title>
                  <Text
                    size="sm"
                    c="rgba(255,255,255,0.85)"
                    maw={260}
                    mx="auto"
                  >
                    {leftMessage}
                  </Text>
                </div>
              </Grid.Col>

              <Grid.Col
                md={7}
                sm={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "2.5rem",
                }}
              >
                <div style={{ width: "100%" }}>
                  <Title order={3} mb={10}>
                    {rightTitle}
                  </Title>
                  <Text color="dimmed" mb={24}>
                    {rightMessage}
                  </Text>
                  <Group direction="column" spacing="sm" grow>
                    {actions.map((action, idx) => (
                      <Button
                        key={idx}
                        component={action.href ? "a" : "button"}
                        href={action.href}
                        onClick={action.onClick}
                        variant={action.variant || "outline"}
                      >
                        {action.label}
                      </Button>
                    ))}
                  </Group>
                </div>
              </Grid.Col>
            </Grid>
          </Card>
        </Center>
      </Container>
    </div>
  );
}

UnauthorizedPage.propTypes = {
  icon: PropTypes.node,
  leftTitle: PropTypes.string,
  leftMessage: PropTypes.string,
  rightTitle: PropTypes.string,
  rightMessage: PropTypes.string,
  leftGradient: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      variant: PropTypes.string,
      href: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
};

export default UnauthorizedPage;
